import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";

const options = {
     confirmButtonColor: "#4683B5",
     cancelButtonColor: "#292D3E",
};

export default {
     install(app) {
          app.use(VueSweetalert2, options);
     },
};
